import type { TrustpilotTestimonialProps } from "components/TrustpilotTestimonial";
import { TrustpilotTestimonial } from "components/TrustpilotTestimonial";
import type { ReactStoryblokComponent } from "types/storyblok";

const TrustpilotTestimonialAdapter = ({
  blok: { srcDesktop, srcMobile, height, alt, cardDesktopPosition = "left" },
  sbEditable,
}: ReactStoryblokComponent<TrustpilotTestimonialProps>) => (
  <TrustpilotTestimonial
    srcDesktop={srcDesktop}
    srcMobile={srcMobile}
    height={height}
    alt={alt}
    cardDesktopPosition={cardDesktopPosition}
    sbEditable={sbEditable}
  />
);

export default TrustpilotTestimonialAdapter;
